<div class="container p-5 !pt-0 !pb-0">
  <!-- General Company Information -->
  <div #container_wrapper id="container_wrapper" class="container_wrapper">
    <mat-panel-title class="custom-panel-title !text-[24px] !text-[#21252A]">
      General Company Information
    </mat-panel-title>

    <ng-container>
      <div
        class="container-fluid flex h-auto p-[29px] !pl-0 !pt-0 !m-[3px] !ml-0 !mb-[0px] !pb-[0px]"
      >
        <div class="!bg-[#ffffff] w-[99%]">
          <h3
            class="!text-[18px] !text-[#21252A] font-semibold !mb-[0px] !pl-0 !pt-0 !ml-0"
          >
            Company Details
          </h3>
          <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 container">
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh] !mb-[40px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.company_name"
                    placeholder="Full Legal Name of Company"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container !mb-[30px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh] !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.address"
                    placeholder="Registered Address"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded !mb-[30px]">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh] !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.company_reg_no"
                    placeholder="Company Registration Number"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container !mb-[13px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh] !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.company_vat_no"
                    placeholder="VAT Registration Number"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container !mb-[13px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    type="email"
                    [value]="responseSubmitted?.email"
                    placeholder="Email"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container ">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.website"
                    placeholder="Website"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container !mb-[30px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    type="number"
                    [value]="responseSubmitted?.phone"
                    placeholder="Telephone"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <h3
            class="!text-[18px] !text-[#21252A] font-semibold !mb-[0px] !pb-[15px] !pt-[12px]"
          >
            Contact Person
          </h3>
          <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 container">
            <div class="container">
              <div class="rounded !mb-[15px]">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.contact_person"
                    placeholder="Name"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container !mb-[15px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.contact_person_position"
                    placeholder="Position"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container !mb-[15px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.contact_person_phone"
                    placeholder="Telephone"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container !mb-[15px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.contact_person_email"
                    placeholder="Email"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <h3
            class="!text-[18px] !text-[#21252A] font-semibold !mb-[0px] !pb-[15px] !pt-[12px]"
          >
            Organization Structure
          </h3>
          <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 container">
            <div class="container !mb-[13px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.legal_status"
                    placeholder="Legal Status (e.g., Sole Trader, Partnership, Limited Company)"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container !mb-[13px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.year_established"
                    placeholder="e.g 1995"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container !mb-[13px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.parent_company"
                    placeholder="Parent Company (if applicable)"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container !mb-[13px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    type="number"
                    [value]="responseSubmitted?.direct_employees"
                    placeholder="Number of Direct Employees"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.subcontractor_count"
                    placeholder="Number of Subcontractors Regularly Used"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <h3
            class="!text-[18px] !text-[#21252A] font-semibold !mb-[0px] !pb-[15px] !pt-[12px]"
          >
            Company Size
          </h3>
          <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 container">
            <div class="container !mb-[13px]" >
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.annual_turnover"
                    placeholder="Annual Turnover for the Past 3 Years"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container !mb-[13px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:!w-full !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.completed_projects"
                    placeholder="Number of Projects Completed (last 3 years):"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded w-[100%]">
                <mat-form-field
                  class="lg:!w-[26.302vw] md:w-[100%] !h-[4.132vh]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.ongoing_projects"
                    placeholder="Total Number of Ongoing Projects"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!--  Health, Safety, and Environmental Management  -->
  <div #container_wrapper id="container_wrapper" class="container_wrapper">
    <ng-container>
      <div
        class="container-fluid flex h-auto p-[29px] !pl-0 !pt-0 !m-[3px] !ml-0 !mt-[5px] !mb-[0px] !pb-[0px]"
      >
        <div class="!p-[30px] !pl-0 !pb-0 !bg-[#ffffff] !pt-[0px]">
          <h3
            class="!text-[20px] !text-[#21252A] font-semibold !mb-[0px] !pt-0 !pb-[1.8rem]"
          >
            Health and Safety Policy
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
          >
            <div class="container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 items-center !w-[69.589vw] !h-[14vh] !mb-[10px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
                >
                  <label>
                    Do you have a Health and Safety Policy in place?
                  </label>
                  <mat-radio-group
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-center"
                    [disabled]="true"
                  >
                    <mat-radio-button
                      value="1"
                      [checked]="responseSubmitted?.has_health_policy === 1"
                      >Yes</mat-radio-button
                    >
                    <mat-radio-button
                      value="0"
                      [checked]="responseSubmitted?.has_health_policy === 0"
                      >No</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
                <div
                  class="flex"
                  *ngFor="let doc of responseSubmitted?.parent_document"
                >
                  <img
                    *ngIf="doc.type === 'health_safety_policy_attach'"
                    [src]="getFileIcon(doc.file_path)"
                    alt="File Preview"
                    class="object-cover w-auto h-[100%] cursor-pointer"
                  />
                  <p *ngIf="doc.type === 'health_safety_policy_attach'">
                    {{ doc.title }}
                  </p>
                </div>
              </div>
            </div>

            <div class="!mt-[6px] !pl-0 !mb-[19px] container p-5 !pt-0 !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 flex items-center !w-[69.589vw] !h-[15vh] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2"
                >
                  <label>
                    Have you had any reportable incidents (e.g., RIDDOR) in the
                    past three years? If yes, please provide details.
                  </label>
                  <mat-radio-group
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-center"
                    [disabled]="true"
                  >
                    <mat-radio-button
                      value="1"
                      [checked]="responseSubmitted?.health_incidents === 1"
                      >Yes</mat-radio-button
                    >
                    <mat-radio-button
                      value="0"
                      [checked]="responseSubmitted?.health_incidents === 0"
                      >No</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div
              class="container p-5 !pl-0 !pt-0 !pb-0 !mt-[29px]"
              *ngIf="responseSubmitted?.health_incidents === 1"
            >
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <mat-form-field
                  class="!w-[69.589vw] !h-[127px] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Provide Detail </mat-label>
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.health_incident_details"
                    placeholder="Provide Detail"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <h3
            class="!text-[18px] !text-[#21252A] font-semibold !mb-[0px] !pt-[12px] !pb-[18px]"
          >
            Safety Accreditation
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
          >
            <div class="container p-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <div
                  class="items-center !w-full grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1"
                >
                  <label>
                    Please provide evidence of any Health and Safety
                    accreditations (e.g., CHAS, Safe Contractor)
                  </label>

                  <div class="bg-[#f7f6fb] max-w-[69.589vw] mb-[10px]">
                    <div
                      class="flex h-[122px] flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
                    >
                      <button
                        type="button"
                        class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                      >
                        Attach File
                      </button>
                      <p class="text-lg font-normal text-[#21252A]">
                        Drag & Drop
                      </p>
                      <input type="file" #fileInputDocument multiple hidden />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex"
            *ngFor="let doc of responseSubmitted?.parent_document"
          >
            <img
              *ngIf="doc.type === 'safety_accr_attach'"
              [src]="getFileIcon(doc.file_path)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
            <p *ngIf="doc.type === 'safety_accr_attach'">
              {{ doc.title }}
            </p>
          </div>

          <h3
            class="!text-[18px] !text-[#21252A] font-semibold !mb-[0px] !pt-[29px] !pb-[18px]"
          >
            Environmental Policy
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container !mb-[41px]"
          >
            <div class="!mt-[6px] !mb-[19px] container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pb-0 !pl-0 !pt-0">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 items-center !w-[69.589vw] !h-[14vh] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2"
                >
                  <label>
                    Do you have an Environmental Management Policy in place?
                  </label>
                  <mat-radio-group
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-center"
                    [disabled]="true"
                  >
                    <mat-radio-button
                      value="1"
                      [checked]="responseSubmitted?.has_env_policy === 1"
                      >Yes</mat-radio-button
                    >
                    <mat-radio-button
                      value="0"
                      [checked]="responseSubmitted?.has_env_policy === 0"
                      >No</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>
            <div
              class="flex"
              *ngFor="let doc of responseSubmitted?.parent_document"
            >
              <img
                *ngIf="doc.type === 'environmental_policy_attach'"
                [src]="getFileIcon(doc.file_path)"
                alt="File Preview"
                class="object-cover w-auto h-[100%] cursor-pointer"
              />
              <p *ngIf="doc.type === 'environmental_policy_attach'">
                {{ doc.title }}
              </p>
            </div>
            <div class="container p-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <div
                  class=" items-center !mb-[10px] !w-full grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1"
                >
                  <label>
                    Provide details of any environmental accreditations (e.g.,
                    ISO 14001)
                  </label>
                  <div class="bg-[#f7f6fb] max-w-[69.589vw]">
                    <div
                      class="flex h-[122px] !w-full flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
                    >
                      <button
                        type="button"
                        class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                      >
                        Attach File
                      </button>
                      <p class="text-lg font-normal text-[#21252A]">
                        Drag & Drop
                      </p>
                      <input type="file" #fileInputDocument multiple hidden />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div
              class="flex"
              *ngFor="let doc of responseSubmitted?.parent_document"
            >
              <img
                *ngIf="doc.type === 'env_accr_attach'"
                [src]="getFileIcon(doc.file_path)"
                alt="File Preview"
                class="object-cover w-auto h-[100%] cursor-pointer"
              />
              <p *ngIf="doc.type === 'env_accr_attach'">
                {{ doc.title }}
              </p>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !pb-0 !mt-[29px]">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <mat-form-field
                  class="!w-[69.589vw] !h-[127px] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label>
                    Sustainability initiatives your company is involved in.
                  </mat-label>
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.sustainability_initiatives"
                    placeholder="Describe any sustainability initiatives your company is involved in."
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="bg-[#f7f6fb] max-w-[69.589vw] mb-[10px] mt-2">
              <div
                class="flex h-[122px] !w-full flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
              >
                <button
                  type="button"
                  class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                >
                  Attach File
                </button>
                <p class="text-lg font-normal text-[#21252A]">
                  Drag & Drop
                </p>
                <input type="file" #fileInputDocument multiple hidden />
              </div>
            </div>
            <div
              class="flex"
              *ngFor="let doc of responseSubmitted?.parent_document"
            >
              <img
                *ngIf="doc.type === 'sustainability_initiatives_attach'"
                [src]="getFileIcon(doc.file_path)"
                alt="File Preview"
                class="object-cover w-auto h-[100%] cursor-pointer"
              />
              <p *ngIf="doc.type === 'sustainability_initiatives_attach'">
                {{ doc.title }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!--  Technical and Professional Capability -->
  <div #container_wrapper id="container_wrapper" class="container_wrapper">
    <ng-container>
      <div
        class="container-fluid flex !justify-left h-auto p-[29px] !pl-0 !pt-0 !m-[3px] !mt-[5px] !mb-[0px] !pb-[0px]"
      >
        <div class="!p-[30px] !pl-0 !pb-0 !bg-[#ffffff] w-full !pt-[0px]">
          <h4
            class="!text-[24px] font-semibold !text-[#21252A] !mb-[0px] !pt-0 !pb-0"
          >
            Relevant Construction Experience
          </h4>
          <h4
            class="!text-[18px] font-semibold !text-[#21252A] !mb-[0px] !pt-[24px] !pb-0"
          >
            Provide details of up to three construction projects that are
            similar in scope and size to this procurement. Include the
            following:
          </h4>
          <ng-container
            *ngIf="
              responseSubmitted?.sample_projects?.length > 0;
              else placeholderProjects
            "
          >
            <ng-container
              *ngFor="
                let project of responseSubmitted?.sample_projects;
                let i = index
              "
            >
              <h4
                class="!text-[20px] font-semibold !mb-[0px] !pt-0 !text-[#21252A]"
              >
                Construction project {{ i + 1 }}
              </h4>
              <div
                class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
              >
                <div class="container">
                  <div class="rounded">
                    <mat-form-field
                      class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                      appearance="outline"
                    >
                      <input
                        readonly
                        matInput
                        [value]="project?.project_name"
                        placeholder="Project Name"
                      />
                    </mat-form-field>
                  </div>
                </div>
                <div class="container">
                  <div class="rounded">
                    <mat-form-field
                      class="lg:!w-[26vw] md:!w-full !h-[4vh] mt-[10px] !mb-[38px]"
                      appearance="outline"
                    >
                      <input
                        readonly
                        matInput
                        [value]="project?.client_name"
                        placeholder="Client Name"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="container">
                  <div class="rounded">
                    <mat-form-field
                      class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                      appearance="outline"
                    >
                      <mat-label>Start Date</mat-label>
                      <input
                        readonly
                        matInput
                        [value]="
                          DateFormatService.formatDate(project?.start_date)
                        "
                        placeholder="Start Date"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="container">
                  <div class="rounded">
                    <mat-form-field
                      class="lg:!w-[26vw] md:!w-full !h-[4vh]"
                      appearance="outline"
                    >
                      <mat-label>End Date</mat-label>
                      <input
                        readonly
                        matInput
                        [value]="
                          DateFormatService.formatDate(project?.completion_date)
                        "
                        placeholder="End Date"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="container">
                  <div class="rounded">
                    <mat-form-field
                      class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[38px]"
                      appearance="outline"
                    >
                      <input
                        readonly
                        type="number"
                        matInput
                        [value]="project?.project_value"
                        placeholder="Project Value"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="container">
                  <div class="rounded">
                    <mat-form-field
                      class="lg:!w-[26vw] md:!w-full !h-[4vh]"
                      appearance="outline"
                    >
                      <input
                        readonly
                        matInput
                        [value]="project?.role"
                        placeholder="Your Role (Main Contractor/Subcontractor)"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="container">
                  <div class="rounded">
                    <mat-form-field
                      class="lg:!w-[26vw] md:!w-full !h-[26.726vh]"
                      appearance="outline"
                    >
                      <input
                        readonly
                        matInput
                        [value]="project?.description_of_work"
                        placeholder="Description of Work"
                      />
                    </mat-form-field>
                  </div>
                </div>
                <div class="container">
                  <div class="rounded">
                    <mat-form-field
                      class="lg:!w-[26vw] md:!w-full !h-[18.768vh]"
                      appearance="outline"
                    >
                      <input
                        readonly
                        matInput
                        [value]="project?.challenges_faced"
                        placeholder="Any Challenges Faced and How They Were Overcome"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <label>Key Achievements</label>
              <div class=" max-w-[69.589vw] h-[122px]">

                <mat-form-field
                class=" w-[69.589vw] h-[122px]"
                appearance="outline"
              >
                <input
                  readonly
                  matInput
                  [value]="project?.key_achievements"
                  placeholder="Key Achievements"
                />
              </mat-form-field>
              </div>

              <div class="bg-[#f7f6fb] max-w-[69.589vw] !mb-[10px] mt-[1rem]">
                <div
                  class="flex h-[122px] !w-full flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
                >
                  <button
                    type="button"
                    class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                  >
                    Attach File
                  </button>
                  <p class="text-lg font-normal text-[#21252A]">
                    Drag & Drop
                  </p>
                  <input type="file" #fileInputDocument multiple hidden />
                </div>
              </div>
              <div
                class="flex"
                *ngFor="let doc of responseSubmitted?.parent_document"
              >
                <img
                  *ngIf="doc.type === 'construction_project1_attach'"
                  [src]="getFileIcon(doc.file_path)"
                  alt="File Preview"
                  class="object-cover w-auto h-[100%] cursor-pointer"
                />
                <p *ngIf="doc.type === 'construction_project1_attach'">
                  {{ doc.title }}
                </p>
              </div>
            </ng-container>
          </ng-container>

          <ng-template #placeholderProjects>
            <ng-container *ngFor="let i of [0, 1, 2]">
              <h4
                class="!text-[20px] font-semibold !mb-[0px] !pt-[15px] !text-[#21252A]"
              >
                Construction project {{ i + 1 }}
              </h4>
              <div
                class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
              >
                <div class="container">
                  <div class="rounded">
                    <mat-form-field
                      class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[0px]"
                      appearance="outline"
                    >
                      <input readonly matInput placeholder="Project Name" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="container">
                  <div class="rounded">
                    <mat-form-field
                      class="lg:!w-[26vw] md:!w-full !h-[4vh] mt-[10px] !mb-[38px]"
                      appearance="outline"
                    >
                      <input readonly matInput placeholder="Client Name" />
                    </mat-form-field>
                  </div>
                </div>

                <div class="container">
                  <div class="rounded">
                    <mat-form-field
                      class="lg:!w-[26vw] md:!w-full !h-[4vh] !mb-[10px]"
                      appearance="outline"
                    >
                      <mat-label>Start Date</mat-label>
                      <input
                        readonly
                        type="date"
                        matInput
                        placeholder="Start Date"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="container p-5 !pl-0 !pb-0 !pt-0">
                  <div class="rounded p-10 !pb-0 !pl-0 !pt-0">
                    <mat-form-field
                      class="!w-[26vw] !h-[4vh]"
                      appearance="outline"
                    >
                      <mat-label>End Date</mat-label>
                      <input
                        readonly
                        type="date"
                        matInput
                        placeholder="End Date"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="container p-5 !pl-0 !pb-0 !pt-0">
                  <div class="rounded p-10 !pb-0 !pl-0 !pt-0">
                    <mat-form-field
                      class="!w-[26vw] !h-[4vh] !mb-[38px]"
                      appearance="outline"
                    >
                      <input
                        readonly
                        type="number"
                        matInput
                        placeholder="Project Value"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="container p-5 !pl-0 !pb-0 !pt-0">
                  <div class="rounded p-10 !pb-0 !pl-0 !pt-0">
                    <mat-form-field
                      class="!w-[26vw] !h-[4vh]"
                      appearance="outline"
                    >
                      <input
                        readonly
                        matInput
                        placeholder="Your Role (Main Contractor/Subcontractor)"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="container p-5 !pl-0 !pb-0 !pt-0">
                  <div class="rounded p-10 !pb-0 !pl-0 !pt-0">
                    <mat-form-field
                      class="!w-[26vw] !h-[26.726vh] !mb-0"
                      appearance="outline"
                    >
                      <input
                        readonly
                        matInput
                        placeholder="Description of Work"
                      />
                    </mat-form-field>
                  </div>
                </div>
                <div class="container p-5 !pl-0 !pb-0 !pt-0">
                  <div class="rounded p-10 !pb-0 !pl-0 !pt-0">
                    <mat-form-field
                      class="!w-[26vw] !h-[6vh]"
                      appearance="outline"
                    >
                      <input
                        readonly
                        matInput
                        placeholder="Any Challenges Faced and How They Were Overcome"
                      />
                    </mat-form-field>
                  </div>
                  <div class="rounded p-10 !pb-0 !pl-0 !pt-0">
                    <mat-form-field class="!w-[26vw]" appearance="outline">
                      <input
                        readonly
                        type="number"
                        matInput
                        placeholder="Key Achievements"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-template>
          <h4
            class="!text-[20px] font-semibold !mb-[0px] !pt-[0px] !text-[#21252A]"
          >
            Key Personnel
          </h4>
          <h4
            class="!text-[16px] font-medium !mb-[0px] !pt-[12px] !pb-[15px] !text-[#21252A]"
          >
            List the key personnel proposed for this project, including:
          </h4>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
          >
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26vw] !w-full !h-[4vh] !mb-[30px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.key_personnel_name"
                    placeholder="Name"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26vw] !w-full !h-[4vh] !mb-[30px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.key_personnel_role"
                    placeholder=" Role on the Project"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26vw] !w-full !h-[4vh] !mb-[30px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.key_personnel_qualifications"
                    placeholder="Qualifications"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26vw] !w-full !h-[4vh] !mb-[30px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.key_personnel_experience"
                    placeholder="Experience (years and relevant projects):"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          <h3
            class="!text-[16px] font-semibold roboto !mb-[0px] !pt-[12px] !pb-[22px] !text-[#21252A]"
          >
            Subcontractors and Supply Chain
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div
              class="!mt-[6px] w-[73.589vw] !mb-[19px] container p-5 !pl-0 !pt-0 !pb-0"
            >
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 flex items-center !w-[69.589vw] !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
                >
                  <label>
                    Do you intend to use subcontractors for this project?
                    <br />If yes, provide details of key subcontractors and
                    their scope of work.
                  </label>
                  <mat-radio-group
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-center"
                    [disabled]="true"
                  >
                    <mat-radio-button
                      value="true"
                      [checked]="responseSubmitted?.use_subcontractors === true"
                      >Yes</mat-radio-button
                    >
                    <mat-radio-button
                      value="false"
                      [checked]="
                        responseSubmitted?.use_subcontractors === false
                      "
                      >No</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div
              class="container p-5 !pt-0 !pl-0 !pb-0 !mt-[29px]"
              *ngIf="responseSubmitted?.use_subcontractors"
            >
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <mat-form-field
                  class="!w-[69.589vw] !h-[127px] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Provide Detail </mat-label>
                  <input
                    readonly
                    matInput
                    [value]="
                      responseSubmitted?.subcontractor_scope_of_work
                        ? responseSubmitted?.subcontractor_scope_of_work
                        : 'Detail not provided by applicant'
                    "
                    placeholder="Provide Detail"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pb-0 !pl-0 !pt-0">
                <mat-form-field
                  class="!w-[69.589vw] !mb-[0px] !h-[223px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.supply_chain_management"
                    placeholder="Describe how you manage your supply chain and ensure subcontractor compliance with project standards."
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Quality Management -->
  <div #container_wrapper id="container_wrapper" class="container_wrapper">
    <ng-container>
      <div
        class="container-fluid flex justify-center h-auto p-[29px] !pl-0 !pt-0 !m-[3px] !mt-[5px] !mb-[0px] !pb-[0px]"
      >
        <div class="!p-[30px] !pl-0 !pb-0 !bg-[#ffffff] w-full !pt-[0px]">
          <h3
            class="!text-[24px] font-semibold !text-[#21252A] !mb-[0px] !pt-0 !pb-[22px]"
          >
            Quality Management System (QMS)
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="!mt-[6px] !mb-[19px] container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pb-0 !pl-0 !pt-0">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 flex items-center !w-[69.589vw] !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
                >
                  <label> Do you have a documented QMS? </label>
                  <mat-radio-group
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-center"
                    [disabled]="true"
                  >
                    <mat-radio-button
                      value="1"
                      [checked]="responseSubmitted?.using_qms === 1"
                      >Yes</mat-radio-button
                    >
                    <mat-radio-button
                      value="0"
                      [checked]="responseSubmitted?.using_qms === 0"
                      >No</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="container p-5 !pt-0 !pl-0 !pb-0">
              <div class="rounded p-10 !pb-0 !pl-0 !pt-0">
                <mat-form-field
                  class="!w-[69.589vw] !mb-[0px] !h-[139px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.quality_certifications_detail"
                    placeholder="Provide details of any quality certifications (e.g., ISO 9001)"
                  />
                </mat-form-field>
              </div>
            </div>
              
            <div
              class="flex"
              *ngFor="let doc of responseSubmitted?.parent_document"
            >
              <img
                *ngIf="doc.type === 'quality_certification_attach'"
                [src]="getFileIcon(doc.file_path)"
                alt="File Preview"
                class="object-cover w-auto h-[100%] cursor-pointer"
              />
              <p *ngIf="doc.type === 'quality_certification_attach'">
                {{ doc.title }}
              </p>
            </div>
            <div class="container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <mat-form-field
                  class="!w-[69.589vw] !mb-[0px] !h-[139px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.compliance_process"
                    placeholder="How do you ensure compliance with quality standards on construction projects?"
                  />
                </mat-form-field>
              </div>
            </div>
              
            <div
              class="flex"
              *ngFor="let doc of responseSubmitted?.parent_document"
            >
              <img
                *ngIf="doc.type === 'quality_standard_attach'"
                [src]="getFileIcon(doc.file_path)"
                alt="File Preview"
                class="object-cover w-auto h-[100%] cursor-pointer"
              />
              <p *ngIf="doc.type === 'quality_standard_attach'">
                {{ doc.title }}
              </p>
            </div>
            <h3
              class="!text-[20px] font-semibold !text-[#21252A] !mb-[0px] !pt-[12px] !pb-[22px]"
            >
              Defects and Warranty
            </h3>

            <div class="container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <mat-form-field
                  class="!w-[69.589vw] !mb-[0px] !h-[139px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.defects_management"
                    placeholder="Outline your approach to managing construction defects during and after project completion."
                  />
                </mat-form-field>
              </div>
            </div>
              
            <div
              class="flex"
              *ngFor="let doc of responseSubmitted?.parent_document"
            >
              <img
                *ngIf="doc.type === 'defects_&_warranty_attach'"
                [src]="getFileIcon(doc.file_path)"
                alt="File Preview"
                class="object-cover w-auto h-[100%] cursor-pointer"
              />
              <p *ngIf="doc.type === 'defects_&_warranty_attach'">
                {{ doc.title }}
              </p>
            </div>
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[28.831vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.warranty_period"
                    placeholder=" Warranty period"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Financial and Insurance Information  -->
  <div #container_wrapper id="container_wrapper" class="container_wrapper">
    <ng-container>
      <div
        class="container-fluid flex justify-center h-auto p-[29px] !pl-0 !pt-0 !m-[3px] !mt-[5px] !mb-[0px] !pb-[0px]"
      >
        <div class="!p-[30px] !pl-0 !pb-0 !bg-[#ffffff] w-full !pt-[0px]">
          <h3
            class="!text-[20px] font-semibold !text-[#21252A] !mb-[0px] !pt-0 !pb-[22px]"
          >
            Financial Information
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <label> Last Year Annual TurnOver </label>
            <div
              class="!mt-5 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !mb-[30px]">
                <div class="rounded !pt-0">
                  <mat-form-field
                    class="lg:!w-[25.683vw] !w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Financial Year </mat-label>
                    <input
                      type="date"
                      matInput
                      readonly
                      [value]="
                        responseSubmitted?.annual_turnover_last_3_years
                          ? responseSubmitted?.annual_turnover_last_3_years[0]
                              ?.year
                          : ''
                      "
                      placeholder=" Financial Year"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="container !mb-[30px]">
                <div class="rounded">
                  <mat-form-field
                    class="lg:!w-[25.683vw] !w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <input
                      matInput
                      type="number"
                      readonly
                      [value]="
                        responseSubmitted?.annual_turnover_last_3_years
                          ? responseSubmitted?.annual_turnover_last_3_years[0]
                              ?.value
                          : ''
                      "
                      placeholder=" Annual Turnover in millions e.g 300"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <label> 2nd Last Year Annual TurnOver </label>
            <div
              class="!mt-5 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !mb-[30px]">
                <div class="rounded">
                  <mat-form-field
                    class="lg:!w-[25.683vw] !w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Financial Year </mat-label>
                    <input
                      type="date"
                      matInput
                      readonly
                      [value]="
                        responseSubmitted?.annual_turnover_last_3_years
                          ? responseSubmitted?.annual_turnover_last_3_years[1]
                              ?.year
                          : ''
                      "
                      placeholder=" Financial Year"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="container !mb-[30px]">
                <div class="rounded">
                  <mat-form-field
                    class="lg:!w-[25.683vw] !w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <input
                      matInput
                      type="number"
                      readonly
                      [value]="
                        responseSubmitted?.annual_turnover_last_3_years
                          ? responseSubmitted?.annual_turnover_last_3_years[1]
                              ?.value
                          : ''
                      "
                      placeholder=" Annual Turnover in millions e.g 300"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <label> 3rd Last Year Annual TurnOver </label>
            <div
              class="!mt-5 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
            >
              <div class="container !mb-[30px]">
                <div class="rounded">
                  <mat-form-field
                    class="lg:!w-[25.683vw] !w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <mat-label> Financial Year </mat-label>
                    <input
                      type="date"
                      matInput
                      readonly
                      [value]="
                        responseSubmitted?.annual_turnover_last_3_years
                          ? responseSubmitted?.annual_turnover_last_3_years[2]
                              ?.year
                          : ''
                      "
                      placeholder=" Financial Year"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="container !mb-[30px]">
                <div class="rounded">
                  <mat-form-field
                    class="lg:!w-[25.683vw] !w-full !text-[#21252A] !h-[5vh] !mb-[0px]"
                    appearance="outline"
                  >
                    <input
                      matInput
                      type="number"
                      readonly
                      [value]="
                        responseSubmitted?.annual_turnover_last_3_years
                          ? responseSubmitted?.annual_turnover_last_3_years[2]
                              ?.value
                          : ''
                      "
                      placeholder=" Annual Turnover in millions e.g 300"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="container p-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <div
                  class="items-center !w-full grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1 !mb-[10px]"
                >
                  <label>
                    Provide a copy of your most recent audited financial
                    accounts.
                  </label>

                  <div class="bg-[#f7f6fb] max-w-[69.589vw]">
                    <div
                      class="flex h-[122px] w-full flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
                    >
                      <button
                        type="button"
                        class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                      >
                        Attach File
                      </button>
                      <p class="text-lg font-normal text-[#21252A]">
                        Drag & Drop
                      </p>
                      <input type="file" #fileInputDocument multiple hidden />
                    </div>
                  </div>
                </div>
              
                <div
                  class="flex"
                  *ngFor="let doc of responseSubmitted?.parent_document"
                >
                  <img
                    *ngIf="doc?.type === 'accounts_audit_report_attach'"
                    [src]="getFileIcon(doc?.file_path)"
                    alt="File Preview"
                    class="object-cover w-auto h-[100%] cursor-pointer"
                  />
                  <p *ngIf="doc.type === 'accounts_audit_report_attach'">
                    {{ doc.title }}
                  </p>
                </div>
              </div>
            </div>

            <div class="!mt-[31px] !mb-[19px] container p-5 !pl-0 !pt-0 !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 items-center !w-[69.589vw] !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2"
                >
                  <label>
                    Have you experienced any financial difficulties in the last
                    five (5) years
                    <br />(e.g., insolvency, administration)?
                  </label>
                  <mat-radio-group
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-center"
                    [disabled]="true"
                  >
                    <mat-radio-button
                      value="1"
                      [checked]="
                        responseSubmitted?.has_faced_financial_difficulty === 1
                      "
                      >Yes</mat-radio-button
                    >
                    <mat-radio-button
                      value="0"
                      [checked]="
                        responseSubmitted?.has_faced_financial_difficulty === 0
                      "
                      >No</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>
            <div class="bg-[#f7f6fb] max-w-[69.589vw] mb-[10px] mt-[2rem]">
              <div
                class="flex h-[122px] !w-full flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
              >
                <button
                  type="button"
                  class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                >
                  Attach File
                </button>
                <p class="text-lg font-normal text-[#21252A]">
                  Drag & Drop
                </p>
                <input type="file" #fileInputDocument multiple hidden />
              </div>
            </div>
          </div>

          <h3
            class="!text-[20px] font-semibold !text-[#21252A] !mb-[0px] !pt-[12px] !pb-[22px]"
          >
            Insurance Cover
          </h3>

          <h3
            class="!text-[18px] font-semibold !mb-[0px] !pt-[20px] !pb-[22px] !text-[#21252A]"
          >
            Employer's Liability Insurance
          </h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container !pb-[22px]"
          >
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.insurance_employer_limit"
                    placeholder="Limit"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Expiry Date </mat-label>
                  <input
                    readonly
                    type="date"
                    matInput
                    [value]="responseSubmitted?.insurance_employer_expiry_date"
                    placeholder="Expiry Date"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <h3
            class="!text-[18px] font-semibold !mb-[0px] !pt-[0px] !pb-[22px] !text-[#21252A]"
          >
            Public Liability Insurance
          </h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container !pb-[22px]"
          >
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="
                      responseSubmitted?.insurance_public_liability_limit
                    "
                    placeholder="Limit"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Expiry Date </mat-label>
                  <input
                    readonly
                    type="date"
                    matInput
                    [value]="
                      responseSubmitted?.insurance_public_liability_expiry_date
                    "
                    placeholder="Expiry Date"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <h3
            class="!text-[18px] font-semibold !mb-[0px] !pt-[0px] !pb-[22px] !text-[#21252A]"
          >
            Professional Indemnity Insurance
          </h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container !pb-[22px]"
          >
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="
                      responseSubmitted?.insurance_professional_indemnity_limit
                    "
                    placeholder="Limit"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Expiry Date </mat-label>
                  <input
                    readonly
                    type="date"
                    matInput
                    [value]="
                      responseSubmitted?.insurance_professional_indemnity_expiry_date
                    "
                    placeholder="Expiry Date"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <h3
            class="!text-[18px] font-semibold !mb-[0px] !pt-[0px] !pb-[22px] !text-[#21252A]"
          >
            Contract Works Insurance (if applicable)
          </h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
          >
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.insurance_contract_works_limit"
                    placeholder="Limit"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Expiry Date </mat-label>
                  <input
                    readonly
                    type="date"
                    matInput
                    [value]="
                      responseSubmitted?.insurance_contract_works_expiry_date
                    "
                    placeholder="Expiry Date"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-[#f7f6fb] max-w-[69.589vw] mb-[10px] !mt-[2rem]">
        <div
          class="flex h-[122px] !w-full flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
        >
          <button
            type="button"
            class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
          >
            Attach File
          </button>
          <p class="text-lg font-normal text-[#21252A]">
            Drag & Drop
          </p>
          <input type="file" #fileInputDocument multiple hidden />
        </div>
      </div>
      <div class="flex" *ngFor="let doc of responseSubmitted?.parent_document">
        <img
          *ngIf="doc.type === 'insurance_attach'"
          [src]="getFileIcon(doc.file_path)"
          alt="File Preview"
          class="object-cover w-auto h-[100%] cursor-pointer"
        />
        <p *ngIf="doc.type === 'insurance_attach'">
          {{ doc.title }}
        </p>
      </div>
    </ng-container>
  </div>

  <!--  Compliance and Legal Information  -->
  <div #container_wrapper id="container_wrapper" class="container_wrapper">
    <ng-container>
      <div
        class="container-fluid flex justify-left h-auto p-[29px] !pl-0 !pt-0 !m-[3px] !mt-[39px] !mb-[0px] !pb-[0px]"
      >
        <div class="!p-[30px] !pl-0 !pb-0 !bg-[#ffffff] w-full !pt-[0px]">
          <h3
            class="!text-[24px] !text-[#21252A] font-semibold !mb-[0px] !pt-0 !pb-[22px]"
          >
            Legal Compliance
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="!mt-[6px] !mb-[19px] container">
              <div class="rounded">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 items-center !w-[69.589vw] !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2"
                >
                  <label>
                    Have there been any regulatory actions or prosecutions
                    against your company in the last five (5) years?
                  </label>
                  <mat-radio-group
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-center"
                    [disabled]="true"
                  >
                    <mat-radio-button
                      value="1"
                      [checked]="responseSubmitted?.has_prosecutions === 1"
                      >Yes</mat-radio-button
                    >
                    <mat-radio-button
                      value="0"
                      [checked]="responseSubmitted?.has_prosecutions === 0"
                      >No</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="!mt-[6px] !mb-[19px] container">
              <div class="rounded">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 items-center w-[69.589vw] !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2"
                >
                  <label>
                    Are you currently involved in any legal disputes related to
                    construction projects?
                    <br />If yes, provide details.
                  </label>
                  <mat-radio-group
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-center"
                    [disabled]="true"
                  >
                    <mat-radio-button
                      value="1"
                      [checked]="
                        responseSubmitted?.has_current_legal_dispute === 1
                      "
                      >Yes</mat-radio-button
                    >
                    <mat-radio-button
                      value="0"
                      [checked]="
                        responseSubmitted?.has_current_legal_dispute === 0
                      "
                      >No</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>
            <div
              class="container p-5 !pl-0 !pt-0 !pb-0 !mt-[29px]"
              *ngIf="responseSubmitted?.has_current_legal_dispute === 1"
            >
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <mat-form-field
                  class="!w-[69.589vw] !h-[127px] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Provide Detail </mat-label>
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.current_legal_dispute_details"
                    placeholder="Provide Detail"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <h3
            class="!text-[20px] font-semibold !text-[#21252A] !mb-[0px] !pt-[12px] !pb-[22px]"
          >
            Ethical Standards
          </h3>
          <div
            class="grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="!mt-[6px] !mb-[19px] container">
              <div class="rounded">
                <div
                  class="long-section !p-10 !pb-0 !pt-0 items-center !w-[69.589vw] !h-[114px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2"
                >
                  <label>
                    Confirm your organisation adheres to anti-bribery,
                    anti-corruption, and ethical business practices.
                  </label>
                  <mat-radio-group
                    aria-label="Health and Safety Policy"
                    class="flex gap-4 justify-center"
                    [disabled]="true"
                  >
                    <mat-radio-button
                      value="1"
                      [checked]="
                        responseSubmitted?.confirm_business_practices === 1
                      "
                      >Yes</mat-radio-button
                    >
                    <mat-radio-button
                      value="0"
                      [checked]="
                        responseSubmitted?.confirm_business_practices === 0
                      "
                      >No</mat-radio-button
                    >
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="rounded">
                <div
                  class=" items-center !w-full grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1"
                >
                  <label>
                    Provide details of any accreditations related to ethical
                    practices (e.g., Ethical Trading Initiative):
                  </label>

                  <div class="bg-[#f7f6fb] max-w-[69.589vw] mb-[10px]">
                    <div
                      class="flex h-[122px] !w-full flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
                    >
                      <button
                        type="button"
                        class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                      >
                        Attach File
                      </button>
                      <p class="text-lg font-normal text-[#21252A]">
                        Drag & Drop
                      </p>
                      <input type="file" #fileInputDocument multiple hidden />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex" *ngFor="let doc of responseSubmitted?.parent_document">
        <img
          *ngIf="doc.type === 'ethical_practices_accreditations_attach'"
          [src]="getFileIcon(doc.file_path)"
          alt="File Preview"
          class="object-cover w-auto h-[100%] cursor-pointer"
        />
        <p *ngIf="doc.type === 'ethical_practices_accreditations_attach'">
          {{ doc.title }}
        </p>
      </div>
    </ng-container>
  </div>

  <!-- Sustainability and Social Value  -->
  <div #container_wrapper id="container_wrapper" class="container_wrapper">
    <ng-container>
      <div
        class="container-fluid flex justify-center h-auto p-[29px] !pl-0 !pt-0 !m-[3px] !mt-[5px] !mb-[0px] !pb-[0px]"
      >
        <div class="!p-[30px] !pl-0 !pb-0 !bg-[#ffffff] w-full !pt-[0px]">
          <h3
            class="!text-[24px] font-semibold !text-[#21252A] !mb-[0px] !pt-0 !pb-[22px]"
          >
            Sustainability
          </h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="!w-[81%] !h-[19.8vh] !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.sustainability_outline"
                    placeholder="Outline how your company promotes sustainability in construction projects."
                  />
                </mat-form-field>
                <div class="bg-[#f7f6fb] max-w-[69.589vw] mb-[10px]">
                  <div
                    class="flex h-[122px] !w-full flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
                  >
                    <button
                      type="button"
                      class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                    >
                      Attach File
                    </button>
                    <p class="text-lg font-normal text-[#21252A]">
                      Drag & Drop
                    </p>
                    <input type="file" #fileInputDocument multiple hidden />
                  </div>
                </div>
                <div class="mb-2">
                  
                <div
                  class="flex flex-wrap gap-2"
                  *ngFor="let doc of responseSubmitted?.parent_document"
                >
                  <img
                    *ngIf="doc.type === 'sust_construction_project_attach'"
                    [src]="getFileIcon(doc.file_path)"
                    alt="File Preview"
                    class="object-cover w-auto h-[100%] cursor-pointer"
                  />
                  <p *ngIf="doc.type === 'sust_construction_project_attach'">
                    {{ doc.title }}
                  </p>
                </div>
              </div>
              </div>
            </div>
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class=" !w-[81%] !h-[19.8vh] !mb-[0px]"
                  appearance="outline"
                >
                  <textarea
                    readonly
                    matInput
                    row="4"
                    [value]="
                      responseSubmitted?.sustainability_initiatives_taken
                    "
                    placeholder="Provide examples of any sustainability initiatives or innovations on previous projects (e.g., carbon reduction, waste management energy efficiency)."
                  ></textarea>
                </mat-form-field>
              </div>
              <div class="bg-[#f7f6fb] max-w-[69.589vw] mb-[10px]">
                <div
                  class="flex h-[122px] !w-full flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
                >
                  <button
                    type="button"
                    class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                  >
                    Attach File
                  </button>
                  <p class="text-lg font-normal text-[#21252A]">
                    Drag & Drop
                  </p>
                  <input type="file" #fileInputDocument multiple hidden />
                </div>
              </div>
              <div class="mb-2">
                
              <div
                class="flex"
                *ngFor="let doc of responseSubmitted?.parent_document"
              >
                <img
                  *ngIf="doc.type === 'sust_initiatives_innovations_attach'"
                  [src]="getFileIcon(doc.file_path)"
                  alt="File Preview"
                  class="object-cover w-auto h-[100%] cursor-pointer"
                />
                <p *ngIf="doc.type === 'sust_initiatives_innovations_attach'">
                  {{ doc.title }}
                </p>
              </div>
            </div>
            </div>
          </div>
          <h3
            class="!text-[20px] font-semibold !text-[#21252A] !mb-[0px] !pt-[0px] !pb-[22px]"
          >
            Social Value
          </h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container"
          >
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class=" !w-[81%] !h-[19.8vh] !mb-[0px]"
                  appearance="outline"
                >
                  <textarea
                    readonly
                    matInput
                    rows="4"
                    [value]="
                      responseSubmitted?.social_contributions_community_and_industry
                    "
                    placeholder="Describe how your company contributes to the local community 
                                                and the wider industry 
                                                (e.g., apprenticeship schemes, community engagement, skills development)."
                  ></textarea>
                </mat-form-field>
                <div class="bg-[#f7f6fb] max-w-[69.589vw] mb-[10px]">
                  <div
                    class="flex h-[122px] !w-full flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
                  >
                    <button
                      type="button"
                      class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                    >
                      Attach File
                    </button>
                    <p class="text-lg font-normal text-[#21252A]">
                      Drag & Drop
                    </p>
                    <input type="file" #fileInputDocument multiple hidden />
                  </div>
                </div>  
                <div
                  class="flex"
                  *ngFor="let doc of responseSubmitted?.parent_document"
                >
                  <img
                    *ngIf="doc.type === 'company_contributes_attach'"
                    [src]="getFileIcon(doc.file_path)"
                    alt="File Preview"
                    class="object-cover w-auto h-[100%] cursor-pointer"
                  />
                  <p *ngIf="doc.type === 'company_contributes_attach'">
                    {{ doc.title }}
                  </p>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class=" !w-[81%] !h-[19.8vh] !mb-[0px]"
                  appearance="outline"
                >
                  <textarea
                    readonly
                    matInput
                    rows="4"
                    [value]="responseSubmitted?.corporate_social_initiatives"
                    placeholder="Are you involved in any corporate social responsibility (CSR) Initiatives?"
                  > </textarea>
                </mat-form-field>
                <div class="bg-[#f7f6fb] max-w-[69.589vw] mb-[10px]">
                  <div
                    class="flex h-[122px] !w-full flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-orange-500 hover:bg-opacity-10"
                  >
                    <button
                      type="button"
                      class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded mt-[25px] hover:bg-[#D9D9D9] focus:outline-none"
                    >
                      Attach File
                    </button>
                    <p class="text-lg font-normal text-[#21252A]">
                      Drag & Drop
                    </p>
                    <input type="file" #fileInputDocument multiple hidden />
                  </div>
                </div>
                <div
                  class="flex"
                  *ngFor="let doc of responseSubmitted?.parent_document"
                >
                  <img
                    *ngIf="
                      doc.type === 'corporate_social_responsibility_attach'
                    "
                    [src]="getFileIcon(doc.file_path)"
                    alt="File Preview"
                    class="object-cover w-auto h-[100%] cursor-pointer"
                  />
                  <p
                    *ngIf="
                      doc.type === 'corporate_social_responsibility_attach'
                    "
                  >
                    {{ doc.title }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Refrences  -->
  <div #container_wrapper id="container_wrapper" class="container_wrapper">
    <mat-panel-title class="custom-panel-title !text-[#21252A]">
      References
    </mat-panel-title>

    <ng-container>
      <div
        class="container-fluid flex justify-center h-auto p-[29px] !pl-0 !pt-0 !m-[3px] !mt-[5px] !mb-[0px] !pb-[0px]"
      >
        <div class="!p-[30px] !pl-0 !pb-0 !bg-[#ffffff] w-full !pt-[0px]">
          <h3
            class="!text-[16px] font-semibold !pl-0 !mb-[0px] !pt-0 !pb-[0px] !text-[#21252A]"
          >
            Provide two references from recent construction projects. Include
            the following details:
          </h3>
          <h3
            class="!text-[18px] font-semibold !mb-[0px] !pt-[22px] !pb-[22px] !text-[#21252A]"
          >
            Refrence 1
          </h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container"
          >
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="
                      responseSubmitted?.references &&
                      responseSubmitted?.references[0]?.client_name
                        ? responseSubmitted?.references[0]?.client_name
                        : ''
                    "
                    placeholder="Client Name"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="
                      responseSubmitted?.references &&
                      responseSubmitted?.references[0]?.project_title
                        ? responseSubmitted?.references[0]?.project_title
                        : ''
                    "
                    placeholder="Project Title"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="
                      responseSubmitted?.references &&
                      responseSubmitted.references[0]?.contact_person
                        ? responseSubmitted.references[0].contact_person
                        : ''
                    "
                    placeholder="Contact Person"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    type="email"
                    [value]="
                      responseSubmitted?.references &&
                      responseSubmitted?.references[0]?.email
                        ? responseSubmitted?.references[0]?.email
                        : ''
                    "
                    placeholder="Email Address"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="
                      responseSubmitted?.references &&
                      responseSubmitted?.references[0]?.phone
                        ? responseSubmitted?.references[0]?.phone
                        : ''
                    "
                    placeholder="Telephone Number"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <h3
            class="!text-[18px] font-semibold !text-[#21252A] !mb-[0px] !pt-[22px] !pb-[22px]"
          >
            Reference 2
          </h3>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container !mb-[0px]"
          >
            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="
                      responseSubmitted?.references &&
                      responseSubmitted?.references[1]?.client_name
                        ? responseSubmitted?.references[1]?.client_name
                        : ''
                    "
                    placeholder="Client Name"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="
                      responseSubmitted?.references &&
                      responseSubmitted?.references[1]?.project_title
                        ? responseSubmitted?.references[1]?.project_title
                        : ''
                    "
                    placeholder="Project Title"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="
                      responseSubmitted?.references &&
                      responseSubmitted?.references[1]?.contact_person
                        ? responseSubmitted?.references[1]?.contact_person
                        : ''
                    "
                    placeholder="Contact Person"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    type="email"
                    [value]="
                      responseSubmitted?.references &&
                      responseSubmitted?.references[1]?.email
                        ? responseSubmitted?.references[1]?.email
                        : ''
                    "
                    placeholder="Email Address"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="
                      responseSubmitted?.references &&
                      responseSubmitted?.references[1]?.phone
                        ? responseSubmitted?.references[1]?.phone
                        : ''
                    "
                    placeholder="Telephone Number"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Declaration -->
  <div #container_wrapper id="container_wrapper" class="container_wrapper">
    <mat-panel-title class="custom-panel-title"> Declaration </mat-panel-title>

    <ng-container>
      <div
        class="container-fluid flex justify-center h-auto p-[29px] !pl-0 !pt-0 !m-[3px] !mt-[5px] !mb-[20px] !pb-[0px]"
      >
        <div class="!p-[30px] !pb-0 !bg-[#ffffff] w-full !pl-0 !pt-[0px]">
          <p
            class="!text-[18px] font-semibold roboto !mb-[0px] !pt-0 !pb-[22px] !text-[#21252A]"
          >
            I confirm that the information provided in this Pre-Qualification
            Questionnaire is accurate and complete. I understand that false
            information could result in disqualification from this procurement
            process.
          </p>
          <p
            class="!text-[20px] font-semibold !mb-[0px] !pt-0 !pl-0 !pb-[22px] !text-[#21252A]"
          >
            Authorized Signatory
          </p>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container "
          >
            <div class="container ">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !h-[4.897vh] "
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.authorized_signatory_name"
                    placeholder="Name"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container !mb-[10px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !h-[4.897vh] !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.authorized_signatory_position"
                    placeholder="Position"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container !mb-[10px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full h-[4.897vh] !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="
                      DateFormatService.formatDate(
                        responseSubmitted?.authorized_signatory_signature_date
                      )
                    "
                    placeholder="Date"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container !mb-[40px]">
              <div class="rounded">
                <mat-form-field
                  class="lg:!w-[26.354vw] !w-full !h-[4.897vh] !mb-[0px]"
                  appearance="outline"
                >
                  <input
                    readonly
                    matInput
                    [value]="responseSubmitted?.authorized_signatory_signature"
                    placeholder="Signature"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
